import React from 'react';
import { cx } from '@emotion/css';

type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const composeButtonComponentWithStyle = (style: string): React.FC<ButtonProps> => {
  return props => (
    <button {...props} className={cx(style, props.className)}>
      {props.children}
    </button>
  );
};
